// Placeholder rails: Home's shape while the catalog and the nightly stats
// docs are still on their way. The rails hide themselves when they have
// nothing (a rail of no tiles reads as a broken app), so without these the
// page opens as an empty dark screen and then pops into content. These stand
// in the same space the real rails will take, so nothing jumps when the data
// lands.
import type { ReactNode } from 'react';
import Rail from './Rail';

/** Enough cells to reach the right edge on a phone: tiles run ~3.3 across,
 *  faces ~5. */
const TILES = 4;
const FACES = 5;

/** Enough of Home's three-across feed to fill the fold. */
const FEED_TILES = 15;

/** A filmstrip rail (Upcoming, Popular, New) waiting on its data. */
export function TileRailSkeleton({ title, icon }: { title: string; icon?: ReactNode }) {
  return (
    <Rail title={title} icon={icon} tiles>
      {Array.from({ length: TILES }, (_, i) => (
        <div className="rail-cell" key={i} aria-hidden="true">
          <div className="skel skel-tile" />
        </div>
      ))}
    </Rail>
  );
}

/** Home's tabbed feed waiting on its data: the same four-across grid, its
 *  first few rows shimmering, so the tab opens on its own shape rather than
 *  on a blank page. */
export function FeedSkeleton() {
  return (
    <div className="technique-grid home-grid" aria-hidden="true">
      {Array.from({ length: FEED_TILES }, (_, i) => (
        <div className="skel skel-tile" key={i} />
      ))}
    </div>
  );
}

/** The face cells of the Spotlight rail, for use inside that rail's own
 *  track — its Promote button is there from the first frame, so only the
 *  creators are stood in for. */
export function FaceSkeletons() {
  return (
    <>
      {Array.from({ length: FACES }, (_, i) => (
        <div className="rail-creator skel-cell" key={i} aria-hidden="true">
          <span className="skel skel-face" />
          <span className="rail-creator-name"><span className="skel skel-name" /></span>
        </div>
      ))}
    </>
  );
}
